var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCzCommercial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 24V10H8v56h61.82V24H42zm-4 38h-7v-6H19v6h-7V14h26v48zm14-14h-6v-6h6v6zm0-12h-6v-6h6v6zm12 12h-6v-6h6v6zm0-12h-6v-6h6v6zM34 48h-6v-6h6v6zm0-12h-6v-6h6v6zm0-12h-6v-6h6v6zM22 48h-6v-6h6v6zm0-12h-6v-6h6v6zm0-12h-6v-6h6v6z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/CZ_Commercial.c689484f.svg";
export { SvgCzCommercial as ReactComponent };